import { Modal } from '@bonanza-social/navigation';
import { startListening, trackEvent } from '@bonanza-social/toolkit/state';
import { openSocialRegistrationModal } from './socialRegistrationForm.slice';

startListening({
  actionCreator: openSocialRegistrationModal,
  effect: (_, { dispatch }) => {
    dispatch(
      trackEvent({
        name: 'sign_up_started',
      }),
    );

    Modal.open({
      namespace: 'registration',
      type: 'SocialRegistrationModal',
      options: {
        hideHeader: true,
      },
      style: {
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: 550,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 800,
        },
        paddingTop: 'space-200',
        backgroundColor: 'screenBackground',
      },
    });
  },
});
